export default "__VITE_ASSET__cIvMIUYz__"